import React from 'react';

function Fullscreen() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M3.371 15.17H0V23.6h8.428v-3.372H3.371V15.17zM0 8.428h3.371V3.371h5.057V0H0v8.428zm20.227 11.8H15.17v3.37H23.6V15.17h-3.372v5.057zM15.17 0v3.371h5.057v5.057H23.6V0H15.17z" />
    </svg>
  );
  /* eslint-enable */
}

export default Fullscreen;



// WEBPACK FOOTER //
// ./src/common/icons/Fullscreen.js